import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export type IVerifyCustomDomainModalActionProps = {
  store: UrlShortenerModalStore
}

export const VerifyCustomDomainModalAction = observer(
  ({ store }: IVerifyCustomDomainModalActionProps) => {
    const {
      handleBack,
      handleVerify,
      openActivateCustomDomainModal,
      isStatusPendingPayment,
      isStatusUnsubscribed,
      isStatusPaymentFailed,
      closeModal,
      loading,
    } = store
    const isVerifyForbidden =
      isStatusPendingPayment || isStatusUnsubscribed || isStatusPaymentFailed
    const onVerify = () => {
      if (isVerifyForbidden) {
        openActivateCustomDomainModal()
      } else {
        void handleVerify()
      }
    }

    return (
      <>
        {isVerifyForbidden ? (
          <Button
            typeBtn={'contained'}
            contained={'secondary'}
            text={'Cancel'}
            onClick={closeModal}
          />
        ) : (
          <Button
            typeBtn={'contained'}
            contained={'secondary'}
            text={'Back'}
            onClick={handleBack}
          />
        )}

        <Button
          typeBtn={'contained'}
          contained={'primary'}
          text={'Verify'}
          onClick={onVerify}
          disabled={loading}
          loading={loading}
        />
      </>
    )
  }
)
